import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import { isPresent } from 'services/operators';
import { ApplicationConfigService } from 'services/application-config.service';
import { createRequestOption } from 'app/shared/util/request-util';
import { getOfferHandlingTypeIdentifier, IOfferHandlingType } from '../models/offer-handling-type.model';

export type EntityResponseType = HttpResponse<IOfferHandlingType>;
export type EntityArrayResponseType = HttpResponse<IOfferHandlingType[]>;

@Injectable({ providedIn: 'root' })
export class OfferHandlingTypeService {
  protected resourceUrl: string;

  constructor(protected http: HttpClient, protected applicationConfigService: ApplicationConfigService) {
    this.resourceUrl = this.applicationConfigService.getEndpointFor('api/offer-handling-types');
  }

  create(offerHandlingType: IOfferHandlingType): Observable<EntityResponseType> {
    return this.http.post<IOfferHandlingType>(this.resourceUrl, offerHandlingType, { observe: 'response' });
  }

  update(offerHandlingType: IOfferHandlingType): Observable<EntityResponseType> {
    return this.http.put<IOfferHandlingType>(`${this.resourceUrl}/${getOfferHandlingTypeIdentifier(offerHandlingType)}`, offerHandlingType, { observe: 'response' });
  }

  partialUpdate(offerHandlingType: IOfferHandlingType): Observable<EntityResponseType> {
    return this.http.patch<IOfferHandlingType>(`${this.resourceUrl}/${getOfferHandlingTypeIdentifier(offerHandlingType)}`, offerHandlingType, { observe: 'response' });
  }

  find(id: number): Observable<EntityResponseType> {
    return this.http.get<IOfferHandlingType>(`${this.resourceUrl}/${id}`, { observe: 'response' });
  }

  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IOfferHandlingType[]>(this.resourceUrl, { params: options, observe: 'response' });
  }

  delete(id: number): Observable<HttpResponse<{}>> {
    return this.http.delete(`${this.resourceUrl}/${id}`, { observe: 'response' });
  }

  addOfferHandlingTypeToCollectionIfMissing(
    offerHandlingTypeCollection: IOfferHandlingType[],
    ...offerHandlingTypesToCheck: (IOfferHandlingType | null | undefined)[]
  ): IOfferHandlingType[] {
    const offerHandlingTypes: IOfferHandlingType[] = offerHandlingTypesToCheck.filter(isPresent);
    if (offerHandlingTypes.length > 0) {
      const offerHandlingTypeCollectionIdentifiers = offerHandlingTypeCollection.map(offerHandlingTypeItem => getOfferHandlingTypeIdentifier(offerHandlingTypeItem));
      const offerHandlingTypesToAdd = offerHandlingTypes.filter(offerHandlingTypeItem => {
        const offerHandlingTypeIdentifier = getOfferHandlingTypeIdentifier(offerHandlingTypeItem);
        if (offerHandlingTypeIdentifier == null || offerHandlingTypeCollectionIdentifiers.includes(offerHandlingTypeIdentifier)) {
          return false;
        }
        offerHandlingTypeCollectionIdentifiers.push(offerHandlingTypeIdentifier);
        return true;
      });
      return [...offerHandlingTypesToAdd, ...offerHandlingTypeCollection];
    }
    return offerHandlingTypeCollection;
  }
}
